jQuery(document).ready(function () {
  // console.log('ready');

  var stickyMenuSelector = "#mobile-header";
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = jQuery(stickyMenuSelector).outerHeight();

  jQuery(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = jQuery(this).scrollTop();

    if (Math.abs(lastScrollTop - st) <= delta) return;

    // console.log("st: " + st + ", lastSrollTop: " + lastScrollTop + ", navbarHeight: " + navbarHeight);
    if (st > lastScrollTop && st > navbarHeight) {
      jQuery(stickyMenuSelector).removeClass("nav-down").addClass("nav-up");
    } else {
      if (st + jQuery(window).height() < jQuery(document).height()) {
        jQuery(stickyMenuSelector).removeClass("nav-up").addClass("nav-down");
      }
    }

    lastScrollTop = st;
  }

  // SIZE GUIDE JS
  var val;

  $("#chain1").click(function () {
    val = $(this).val();
    if (val != 0 || val != "") {
      var data_c = [];
      var data_1 = [];
      var data_v;
      $(".hidden_section li").each(function () {
        var a = $(this).attr("class");
        if (a.indexOf(val) > -1) {
          data_new = $(this).attr("class").split("_");
          data_r = data_new[1];
          if (data_r != null || data_r != "undefined" || data_r != "") {
            data_c.push(data_r);
          }
        }
      });
      var html2, html3;
      data_v = data_c.unique();
      filtered_val = data_v.filter((item) => item);
      filtered_val.sort();
      var first_el = first(filtered_val);
      var first_selection = val + "_" + first_el;
      var str3 = [];
      $(".hidden_section li").each(function () {
        var a = $(this).attr("class");
        //console.log(a);
        if (
          a.indexOf(first_selection) > -1 &&
          a.indexOf(first_selection) == 0
        ) {
          data_news = $(this).attr("class").split("_");
          data_rs = data_news[2];

          if (data_rs != null || data_rs != "undefined" || data_rs != "") {
            str3.push(data_rs);
          }
        }
      });
      data_vs = str3.unique();
      filtered_vals = data_vs.filter((item) => item);
      filtered_vals.sort();
      $.each(filtered_val, function () {
        if (this.indexOf("fynch") > -1) {
          html2 += '<option value="' + this + '">' + this + "</option>";
        } else {
          html2 +=
            '<option value="' +
            this +
            '">' +
            this.replace(/-/g, " ") +
            "</option>";
        }
      });
      $("#chain2").html(html2);
      $.each(filtered_vals, function () {
        html3 +=
          '<option value="' +
          this +
          '">' +
          this.replace(/-/g, " ") +
          "</option>";
      });
      $("#chain3").html(html3);
    } else {
      $("#chain2").hide();
      $("#chain3").hide();
    }
  });
  $("#chain2").click(function () {
    val = $(this).val();
    first_sel_val = $("#chain1").children("option:selected").val();
    var combinedata = first_sel_val + "_" + val;
    var str3;

    console.log(combinedata);
    var data_array = [];
    if (val != 0 || val != "") {
      $(".hidden_section li").each(function () {
        var a = $(this).attr("class");
        if (a.indexOf(combinedata) > -1 && a.indexOf(combinedata) == 0) {
          data_news = $(this).attr("class").split("_");
          data_rd = data_news[2];
          if (data_rd != null || data_rd != "undefined" || data_rd != "") {
            data_array.push(data_rd);
          }
        }
      });

      data_vsd = data_array.unique();
      filtered_valsd = data_vsd.filter((item) => item);
      filtered_valsd.sort();
      var html3;
      //console.log(data_array);
      if (
        (data_array != null || data_array != "undefined" || data_array != "") &&
        data_array.length > 0
      ) {
        $.each(filtered_valsd, function () {
          html3 +=
            '<option value="' +
            this +
            '">' +
            this.replace(/-/g, " ") +
            "</option>";
        });
        //console.log("hiii"+data_array);
        $("#chain3").html(html3);
        $("#fff").show();
      } else {
        html3 = "";
        $("#chain3").html("");
        $("#fff").hide();
      }
    } else {
      $("#chain2").hide();
      $("#chain3").hide();
    }
  });

  $("#fff").click(function () {
    var first_selection = $("#chain1").children("option:selected").val();
    var second_selection = $("#chain2").children("option:selected").val();
    var third_selection = $("#chain3").children("option:selected").val();

    var first_selection_lower = first_selection.toLowerCase();
    var second_selection_lower = second_selection.toLowerCase();
    var third_selection_lower = third_selection.toLowerCase();

    var full_url =
      first_selection_lower +
      "_" +
      second_selection_lower +
      "_" +
      third_selection_lower;
    console.log(full_url);
    $.getJSON("/pages/" + full_url + ".json", function (product) {
      content = product.page.body_html;
      if (content) {
        $(".main_cover_page").html(content);
      } else {
        $(".main_cover_page").html(
          '<p class="text-center">No size chart available for this category</p>'
        );
      }
    }).fail(function () {
      $(".main_cover_page").html(
        '<p class="text-center">No size chart available for this category</p>'
      );
      console.log("error");
    });
  });
  // Product page Accordion
  jQuery('.custom-accordion > dt > a.active').trigger('click');
  /*
    const $faqHeading = jQuery('.custom-accordion > dt > a');
  
    $faqHeading.off('click activate').on('click activate', function () {
      const faqIcons = jQuery(this).find('.icon');
  
      const state = jQuery(this).attr('aria-expanded') === 'false';
      jQuery(this).attr('aria-expanded', state);
      jQuery(this).parent().next().slideToggle(() => {
        if (faqIcons.hasClass('icon--active')) {
          faqIcons.toggleClass('icon--active');
        }
      });
      jQuery(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
  
    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
    */
});
